import { getRatingStyles } from "./Rating.styles";
import type { RatingProps } from "./Rating.types";

/**
 * Subcomponente interno para renderizar o ícone de estrela (preenchida ou vazia).
 * Usamos SVG inline para manter o componente autocontido,
 * e 'currentColor' para herdar as cores do Tailwind.
 */
const StarIcon = ({
  isFilled,
  className,
  size,
}: {
  isFilled: boolean;
  className: string;
  size: number;
}) => (
  <>
    {isFilled ? (
      <i className="fi fi-ss-star text-primary"></i>
    ) : (
      <i className="fi fi-rs-star text-primary/50"></i>
    )}
  </>
);

export const Rating = ({ value, size = 24, className }: RatingProps) => {
  const styles = getRatingStyles(className);
  const starArray = [1, 2, 3, 4, 5];

  // Garante que o valor esteja entre 0 e 5
  const clampedValue = Math.max(0, Math.min(5, value));

  return (
    <div className={styles.container}>
      {starArray.map((starValue) => {
        const isFilled = starValue <= clampedValue;
        return (
          <StarIcon
            key={starValue}
            isFilled={isFilled}
            className={styles.star(isFilled)}
            size={size}
          />
        );
      })}
    </div>
  );
};
